import { createContext, useContext } from 'react';

interface OnboardingContextType {
  openTutorial: () => void;
}

export const OnboardingContext = createContext<OnboardingContextType | null>(null);

export function useOnboarding() {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within OnboardingProvider');
  }
  return context;
}
